/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmConversationsDelete } from "../../funcs/llmConversationsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConversationsDeleteRequest$inboundSchema,
};

export const tool$llmConversationsDelete: ToolDefinition<typeof args> = {
  name: "llm-conversations-delete",
  description: `Delete a conversation

Delete a conversation. Items in the conversation will not be deleted.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmConversationsDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
